export const PACKAGE_SEGMENT_STOPWORDS = new Set([
  // Tier 1 — reverse-domain / TLD noise
  "com",
  "org",
  "net",
  "io",
  "edu",
  "gov",
  "app",
  "dev",
  "me",
  "co",
  "uk",
  "de",
  "fr",
  "it",
  "us",
  "eu",
  // Tier 2 — platform & device noise
  "ios",
  "android",
  "iphone",
  "ipad",
  "ipod",
  "mobile",
  "tablet",
  "watch",
  "tv",
  "mac",
  "osx",
  "windows",
  "linux",
  "web",
  "desktop",
  "phone",
  // Tier 3 — generic product / build noise
  "client",
  "lite",
  "pro",
  "plus",
  "free",
  "beta",
  "alpha",
  "demo",
  "test",
  "debug",
  "release",
  "staging",
  "prod",
  "production",
  "main",
  "core",
  "common",
  "shared",
  "lib",
  "utils",
  "helper",
  "service",
  "services",
  "sdk",
  "api",
  "plugin",
  "extension",
  "widget",
  "appstore",
  "playstore",
]);

export const MIN_SIGNAL_TOKEN_LENGTH = 3;

export const APP_TOKEN_SPLIT = /[.-]+/;

export function tokenizeAppSegments(value: string): string[] {
  return value
    .split(APP_TOKEN_SPLIT)
    .map((segment) => segment.trim().toLowerCase())
    .filter(Boolean);
}

export function isPackageSegmentStopword(token: string): boolean {
  return PACKAGE_SEGMENT_STOPWORDS.has(token.trim().toLowerCase());
}

export function isSignalAppToken(token: string): boolean {
  return token.length >= MIN_SIGNAL_TOKEN_LENGTH && !isPackageSegmentStopword(token);
}

export function rankAppTokens(tokens: Iterable<string>): string[] {
  return [...new Set(tokens)].sort((a, b) => b.length - a.length || a.localeCompare(b));
}

export function rankIdentifierSignalTokens(identifier: string): string[] {
  return rankAppTokens(tokenizeAppSegments(identifier).filter(isSignalAppToken));
}
